import { render, staticRenderFns } from "./PointFormDialog.vue?vue&type=template&id=63ff2041&lang=html"
import script from "./PointFormDialog.vue?vue&type=script&lang=js"
export * from "./PointFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports